import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Legitimacy } from '../components/Legitimacy';
import { AboutOSSD } from '../components/AboutOSSD';
import { WhyEduNexa } from '../components/WhyEduNexa';
import { ProgramStructure } from '../components/ProgramStructure';
import { UniversityPartners } from '../components/UniversityPartners';
import { Testimonials } from '../components/Testimonials';
import { AdmissionInfo } from '../components/AdmissionInfo';
import { AdmissionProcess } from '../components/AdmissionProcess';
import { FAQ } from '../components/FAQ';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Legitimacy />
      <AboutOSSD />
      <WhyEduNexa />
      <ProgramStructure />
      <UniversityPartners />
      <Testimonials />
      <AdmissionInfo />
      <AdmissionProcess />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
